import Model from './model.js';
import Log from 'lib/log';
const log = Log('newModels/payroll-item-integration');

export default class PayrollItemIntegration extends Model {
    urlRoot() { return '/PayrollItemIntegrations'; }

    defaults() {
        return {
            payrollItemId: null,
            remoteId: null,
            syncedAt: new Date()
        };
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this.payrollItem = this.getPayrollItem();
    }

    constraints() {
        return {
            companyId: {presence: true},
            integrationId: {presence: true}
        };
    }

    getPayrollItem() {
        if (this.payrollItem) {
            return this.payrollItem;
        }
        return this._setPayrollItem(this.get('payrollItemId'));
    }

    _setPayrollItem(id) {
        if (!app.payrollItems) {
            log.warn(`App hasn't any payroll items loaded`);
            return;
        }

        if (!id) {
            log.warn(`Payroll item integration doesn't have a payroll item`);
            return;
        }

        this.payrollItem = app.payrollItems.find(model => {
            return model.id === id;
        });

        return this.payrollItem;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/payroll-item-integration.js